module.exports = __webpack_public_path__ + "media/src/img/payment/ApplePay-5084ac1a83f719f450a42d97b23acf68.svg";